// extracted by mini-css-extract-plugin
module.exports = {"danger_tip":"danger_tip--1apk0","textarea":"textarea--CQH_2","textarea_len":"textarea_len--hy0oE","text":"text--Nu7ks"};